import React, { useState, useEffect } from 'react';
import { RealInput } from './SalarySettingStyled';

const formatComma = val => {
  if (val === 0 || val === '' || val == null) return '';
  return Number(val).toLocaleString('ko-KR', { maximumFractionDigits: 10 });
};

const parseComma = str => {
  const num = Number(str.replace(/,/g, ''));
  return isNaN(num) ? 0 : num;
};

// %(요율) 입력에도 쓰이므로 기본적으로 소수점을 허용한다. 정수부만 콤마로 묶고 소수부는
// 그대로 둔다. 백엔드가 정수로만 파싱하는 값(예: 근로수당 배율 직접입력)에는
// allowDecimal={false}로 꺼서 소수점 자체를 입력할 수 없게 막는다.
const CommaInput = ({ value, onChange, inputWidth, textAlign, placeholder = '0', style, allowDecimal = true }) => {
  const [display, setDisplay] = useState(formatComma(value));

  useEffect(() => {
    // 소수점을 입력하는 도중(예: "3.")에는 값이 아직 반올림 전이라, 외부 value 와 지금
    // 화면에 보이는 값이 실질적으로 같으면 다시 포맷하지 않는다 — 안 그러면 "3." 이 "3" 으로
    // 되돌아가서 그 뒤에 소수점 이하를 입력할 수 없게 된다.
    if (parseComma(display) !== (value || 0)) {
      setDisplay(formatComma(value));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  const handleChange = e => {
    if (!allowDecimal) {
      const raw = e.target.value.replace(/[^0-9]/g, '');
      const num = raw === '' ? 0 : Number(raw);
      setDisplay(num === 0 ? '' : num.toLocaleString('ko-KR'));
      onChange(num);
      return;
    }
    const raw = e.target.value.replace(/[^0-9.]/g, '');
    // 소수점은 하나만 허용 — 두 번째부터는 버린다.
    const firstDot = raw.indexOf('.');
    const cleaned = firstDot === -1
      ? raw
      : raw.slice(0, firstDot + 1) + raw.slice(firstDot + 1).replace(/\./g, '');
    const [intPart, decPart] = cleaned.split('.');
    const formattedInt = intPart === '' ? '' : Number(intPart).toLocaleString('ko-KR');
    const nextDisplay = decPart !== undefined ? `${formattedInt}.${decPart}` : formattedInt;
    setDisplay(nextDisplay);
    const num = cleaned === '' || cleaned === '.' ? 0 : Number(cleaned);
    onChange(isNaN(num) ? 0 : num);
  };

  return (
    <RealInput
      inputWidth={inputWidth}
      textAlign={textAlign}
      placeholder={placeholder}
      value={display}
      onChange={handleChange}
      style={style}
    />
  );
};

export default CommaInput;
